<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('searchVue.axtarNticlri')"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-8 ">
          <div
            v-if="requests.length <1"
            class="card"
          >
            <div class="card-body text-center">
              <feather
                type="search"
                size="100"
                stroke="#aaa"
              />
              <br>

              <strong>"{{ $route.query['keyword'] }}"</strong> {{ $t('searchVue.axtarSznUyunSoruYoxdurVYaMvcudOlaBilckSoruBalanmdr') }}
            </div>
          </div>

          <div
            v-for="r in requests"
            :key="r.id"
          >
            <RequestItem
              :active-tab="'request'"
              :r="r"
            />
          </div>
        </div>
        <div class="col-xl-4 " />
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getSearchResult,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName, showLimitExceedPopup} from "@/repositories/Utils";
import RequestItem from "@/components/parts/RequestItem.vue";

export default {
  components: {RequestItem},
  data() {
    return {
      mediaBase: mediaBase,
      requests: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),


  },
  watch: {
    "$route"() {
      this.getMyRequests();
    }
  },
  mounted() {
    this.getMyRequests();
  },
  methods: {
    companyProfiles(companyId) {
      let list = [];
      this.profiles.forEach(p => {
        if (p.company.id === companyId) {
          list.push(p);
        }
      })
      return list;
    },

    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getMyRequests() {
      getSearchResult(this.token, this.$route.query['keyword']).then(data => {
        if (data.code === 200) {

          this.requests = data.requests;

        }  else if (data.code === 425) {
          showLimitExceedPopup(this.$swal,data.message, data.errorCode, false);
        }  else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    }
  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
